// our service
const SERVICE = 'forge-ui';

export const createAtlAttributionHeader = (workspaceAri?: string): string => {
	return JSON.stringify({
		atlWorkspaceAri: workspaceAri,
		service: SERVICE,
	});
};
